import React from 'react';
import { ALERT_TYPES } from '@etiquette-ui/alert-dialog';
import { AcceptLink } from 'components/Buttons';
import { getAlertBody } from 'pages/home/pages/Reservations/alert/utils';

const ViewDetails = ({ globalState, item }) => {
  return (
    <AcceptLink
      style={{ alignSelf: 'center', textAlign: 'center' }}
      onClick={() => {
        globalState.config
          .alert({
            type: ALERT_TYPES.CUSTOM,
            config: {
              props: {
                id: item.id,
              },
              body: getAlertBody(item),
            },
          })
          .catch((e) => {});
      }}
    >
      {globalState.config.translate('View Details')}
    </AcceptLink>
  );
};

export default ViewDetails;
